<template>
	<div>
		<kefuright></kefuright>
		<div class="allbox">
			<div class="banxin">
				<!-- 科汇学院 -->
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">科汇云学院</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="kehuibox">
					<div class="kehuitop" v-if="jiActive === 0">
						<img src="../../../assets/img/images/huihui_03.png" class="kehuipic" alt="" />
						<div class="kehuiyou" @click="goTo(1)">
							<div class="ketitle">
								科汇云
							</div>
							<div class="keline"></div>
							<div class="kehuitxt threelines">
								科汇云一直以技术转移、知识产权、政策应用、科技金融、科技项目全过程咨询和政府科技活动等主要研究方向，集企业、高校、科研院所及政府为一体的综合供需体...
							</div>
						</div>
					</div>
					<div class="kehuitop" v-if="jiActive === 1" @click="goTo(2)">
						<img src="../../../assets/img/images/huihui_03.png" class="kehuipic" alt="" />
						<div class="kehuiyou">
							<div class="ketitle">
								火炬报表填报操作实务
							</div>
							<div class="keline"></div>
							<div class="kehuitxt threelines">
								火炬报表填报操作实务一直以技术转移、知识产权、政策应用、科技金融、科技项目全过程咨询和政府科技活动等主要研究方向，集企业、高校、科研院所及政府为一体的综合供需体...
							</div>
						</div>
					</div>
					<div class="kehuitop" v-if="jiActive === 2" @click="goTo(3)">
						<img src="../../../assets/img/images/huihui_03.png" class="kehuipic" alt="" />
						<div class="kehuiyou">
							<div class="ketitle">
								税务大讲堂
							</div>
							<div class="keline"></div>
							<div class="kehuitxt threelines">
								税务大讲堂一直以技术转移、知识产权、政策应用、科技金融、科技项目全过程咨询和政府科技活动等主要研究方向，集企业、高校、科研院所及政府为一体的综合供需体...
							</div>
						</div>
					</div>
					<!-- <div class="kehuitop" v-if="jiActive === 3">
						<img src="../../../assets/img/images/huihui_03.png" class="kehuipic" alt="" />
						<div class="kehuiyou">
							<div class="ketitle">
								进入科汇学院
							</div>
							<div class="keline"></div>
							<div class="kehuitxt threelines">
								进入科汇学院一直以技术转移、知识产权、政策应用、科技金融、科技项目全过程咨询和政府科技活动等主要研究方向，集企业、高校、科研院所及政府为一体的综合供需体...
							</div>
						</div>
					</div> -->
					<div class="keqie">
						<div class="qieli" v-for="(item,index) in jiList" :key="index"
							:class="{ qieliavtive: jiActive == index }" @mousemove="qieTab(index)">
							<div class="qietitle">
								{{item.title}}
							</div>
							<div class="qieline"></div>
						</div>
						<div class="qieli" @click="ke_hui">
							<div class="qietitle">
								进入科汇学院
							</div>
							<div class="qieline"></div>
						</div>
					</div>
				</div>

				<!-- 知识产权价值测试 -->
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">知识产权价值测试</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="zhengyxy">
					通过企业提供的知识产权成果，根据国家知识产权标准，检测企业自主创新能力。平台的自有的检测依据，采取全要素的数据收集，进行企业检测
				</div>
				<div class="quanbox">
					<div class="quangrow">
						<div class="quantitle">
							知识产权价值测试
						</div>
						<div class="quanline"></div>
						<div class="quanhuitxt">
							知识经济时代已成为个人财富、企业生存发展、国家富强的重要凭证。由于蕴藏着巨大的经济价值，知识产权许可、出资等交易活动日益频繁，如何让衡量和确定知识产权价值量常常依赖于知识产权价值评估。通过企业提供的知识产权成果根据国家知识产权标准，检测企业自主创新能力。平台的自有的检测依据,采取全要素的数据收集，进行企业检测。
						</div>
						<div class="jinlan" @click="ceshi_ji">
							进入测试页面
						</div>
					</div>
					<img src="../../../assets/img/images/quana_07.png" class="quanpic" alt="" />
				</div>

				<!-- 企业创新能力分析 -->
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">企业创新能力分析</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="zhengyxy">
					平台根据国家提出的科学发展纲要，主要从企业的知识产权、科技成果转化能力、研发组织管理水平、企业成长性的四项指标综合检测企业的创新能力
				</div>
				<div class="quanbox">
					<img src="../../../assets/img/images/quanb_06.png" class="quanpic" alt="" />
					<div class="quangrow">
						<div class="quantitle">
							企业创新能力分析
						</div>
						<div class="quanline"></div>
						<div class="quanhuitxt">
							企业创新能力在衡量企业的综合指标中所占的地位越来越重要。在市场化的今天，技术创新已是生存发展的不竭动力，从技术创新的决策能力、创新实施能力、技术创新的实现能力及创新的管理能力出发，组织生产要素，建立起高效、科学的创新能力生态体系。
						</div>
						<div class="jinlan" @click="qi_ye">
							进入分析页面
						</div>
					</div>

				</div>

				<!-- 高新技术企业合规性分析 -->
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">高新技术企业合规性分析</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="zhengyxy">
					通过线上监测和线下收集企业大数据，根据高新技术企业政策指导，摸底查出企业高新技术能力
				</div>
				<div class="quanbox">
					<div class="quangrow">
						<div class="quantitle">
							高新技术企业合规性分析
						</div>
						<div class="quanline"></div>
						<div class="quanhuitxt">
							高新技术企业的申报主要是促进创新型企业的发展，让优惠政策落实到实处，在国家重点领域进行研究开发的技术成果，形成自主知识产权，在“八大领域、三个持续和八个条件”的典型特征的基础上，进而提高创新能力，从而实现企业创新驱动发展的动能转换。
						</div>
						<div class="jinlan" @click="gao_xin">
							进入分析页面
						</div>
					</div>
					<img src="../../../assets/img/images/quanc_10.png" class="quanpic" alt="" />
				</div>
				<!-- 政策匹配系统 -->
				<div class="qiyetop">
					<img src="../../../assets/img/images/tl_06.png" class="zhengpic" alt="" />
					<div class="zhengtitle">政策匹配系统</div>
					<img src="../../../assets/img/images/tr_07.png" class="zhengpic" alt="" />
				</div>
				<div class="zhengyxy">
					平台收纳技术成果转化最新政策，自动为企业实际情况匹配相关政策
				</div>

				<div class="rennei">
					<div class="renleft">
						<div class="renli" v-for="(item , index) in tongList"
							:class="{ renliactive: isActive == index }" :key="index" @mousemove="tongtab(index)">
							<img :src="isActive == index ? item.chose : item.nochose" class="renpic" alt="" />
							<div class="rencen">
								<div class="centitle">
									{{item.name}}
								</div>
								<div class="centxt oneline">
									{{item.txt}}
								</div>
							</div>
							<img src="../../../assets/img/images/hf_03.png" class="renrr" alt="" />
							<img src="../../../assets/img/images/hfa_03.png" class="renact" alt="" />
						</div>
					</div>
					<div class="renda">
						<img src="../../../assets/img/images/quand_14.png" class="rendapic" alt="" />
						<div class="rending" @click="pi_pei">
							进入匹配页面
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import kefuright from '../../../components/common/kefu';
	import $ from 'jquery'
	import {
		lesson_type
	} from "../../common/js/api";
	export default {
		name: "chuanggj",
		components: {
			kefuright
		},
		data() {
			return {
				jiList: [{
						id: 1,
						title: '高新技术企业申报操作'
					},
					{
						id: 2,
						title: '火炬报表填报操作实务'
					},
					{
						id: 3,
						title: '税务大讲堂'
					}
				],
				jiActive: 0,
				// 政策匹配系统
				tongList: [{
						id: 1,
						name: '财力投入',
						txt: '为贯彻落实《国家中...',
						chose: require("../../../assets/img/images/uaa_10.png"),
						nochose: require('../../../assets/img/images/ua_10.png')
					},
					{
						id: 2,
						name: '税收优惠',
						txt: '企业符合条件的技术',
						chose: require("../../../assets/img/images/uba_11.png"),
						nochose: require('../../../assets/img/images/ub_11.png')
					},
					{
						id: 3,
						name: '金融支持',
						txt: '扩大创业投资引导基',
						chose: require("../../../assets/img/images/uca_11.png"),
						nochose: require('../../../assets/img/images/uc_11.png')
					},
					{
						id: 4,
						name: '政府采购',
						txt: '国内企业或科研机构',
						chose: require("../../../assets/img/images/uda_11.png"),
						nochose: require('../../../assets/img/images/ud_11.png')
					},
				],
				isActive: 0,
			}
		},
		created() {

		},
		methods: {
			qieTab(index) {
				this.jiActive = index
			},
			goTo(id){
				this.$router.push({
					path: '/kehuixy',
				})
			},
			// 政策匹配系统
			tongtab(index) {
				this.isActive = index;
			},
			ke_hui() {
				this.$router.push({
					path: '/kehuixy',
				})
			},
			getIndex(imgUrl) {
				this.ImgUrl = imgUrl;
			},
			pi_pei() {
				this.$router.push({
					path: '/zhengcepp',
				})
			},
			gao_xin() {
				this.$router.push({
					path: '/qiyecx',
				})
			},
			qi_ye() {
				this.$router.push({
					path: '/qiyecx',
				})
			},
			ceshi_ji() {
				this.$router.push({
					path: '/ceshijz',
				})
			},
			ke_hui() {
				this.$router.push({
					path: '/kehuixy',
				})
			},
			zhuan_jia() {

			},
			mouseLists(item, index) { //鼠标移入时
				console.log(item)
				this.ImgUrls = item.url;
				this.$forceUpdate()
				this.currentIndexs = index
			},

			tabClicks(item, index) {
				this.currentIndexs = index

				console.log(item);
			}
		},
		mounted() {
			var hash = window.location.hash;
			console.log(window.location.hash)
			var index = hash.lastIndexOf("#");
			if (index != -1) {
				var id = hash.substring(index + 1, hash.length + 1);
				var div = document.getElementById(id);
				if (div) {
					setTimeout(function() {
						// console.log($(div).offset().top);
						//$('html,body').scrollTop($(div).offset().top - 43);
						$('html, body').animate({
							scrollTop: $(div).offset().top - 43
						}, 500)
					}, 500);
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.banxin {
		width: 1400px;
		margin: 0 auto;
	}

	.pt60 {
		padding-top: 60px;
	}

	.qiyetop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 25px;

		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.zhengyxy {
		font-size: 16px;
		color: #888888;
		text-align: center;
		padding-bottom: 28px;
	}

	.gongtop {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 25px;

		.zhengpic {
			width: 118px;
			height: 27px;
			flex-shrink: 0;
		}

		.zhengtitle {
			font-size: 36px;
			color: #222222;
			font-weight: bold;
			padding: 0 35px;
		}

		.zhengbai {
			font-size: 36px;
			color: #ffffff;
			font-weight: bold;
			padding: 0 35px;
		}
	}

	.allbox {
		padding: 60px 0;
		background-color: #f6f6f6;

		.kehuibox {
			background-color: #ffffff;
			margin-bottom: 80px;
			margin-top: 30px;

			.kehuitop {
				display: flex;
				align-items: flex-start;
				height: 328px;
				
				.kehuipic {
					width: 765px;
					height: 328px;
					flex-shrink: 0;
					cursor: pointer;
				}

				.kehuiyou {
					padding-top: 45px;
					padding-left: 30px;
					width: 560px;
					cursor: pointer;
					.ketitle {
						font-size: 30px;
						color: #333333;
						font-weight: bold;
						padding-bottom: 25px;
					}

					.keline {
						width: 28px;
						height: 7px;
						border-radius: 30px;
						background-color: #0289f4;
					}

					.kehuitxt {
						font-size: 16px;
						color: #888888;
						padding-top: 50px;
						line-height: 32px;
					}
				}
				.kehuiyou:hover{
					.ketitle {
						color: #0289f4;
					}
				}
			}

			.keqie {
				height: 85px;
				display: flex;
				align-items: center;
				border: 1px solid #eeeeee;

				.qieli:nth-child(4) {
					border: none;
				}

				.qieli {
					cursor: pointer;
					width: 25%;
					height: 100%;
					text-align: center;
					position: relative;
					border-right: 1px solid #eeeeee;

					.qietitle {
						font-size: 24px;
						color: #222222;
						font-weight: bold;
						line-height: 85px;
					}

					.qieline {
						width: 100%;
						position: absolute;
						left: 0;
						bottom: 0;
						height: 4px;
						background-color: #0289f4;
						display: none;
					}
				}

				.qieliavtive {
					.qieline {
						display: block;
					}
				}
			}
		}

		.quanbox {
			display: flex;
			background-color: #ffffff;
			height: 450px;
			margin-bottom: 60px;

			.quangrow {
				flex-grow: 1;
				padding: 50px 30px 0 40px;

				.quantitle {
					font-size: 30px;
					color: #333333;
					font-weight: bold;
					padding-bottom: 25px;
				}

				.quanline {
					width: 28px;
					height: 7px;
					border-radius: 30px;
					background-color: #0289f4;
				}

				.quanhuitxt {
					font-size: 16px;
					color: #888888;
					padding-top: 50px;
					line-height: 32px;
				}

				.jinlan {
					text-align: center;
					width: 205px;
					height: 40px;
					background-color: #0289f4;
					line-height: 40px;
					color: #ffffff;
					cursor: pointer;
					font-size: 18px;
					margin-top: 34px;
				}
			}

			.quanpic {
				width: 800px;
				height: 450px;
				flex-shrink: 0;
			}
		}

		.quanbox:hover {
			.quangrow {
				.quantitle {
					color: #0289f4;
				}
			}
		}
	}

	.rennei {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding-bottom: 40px;

		.renleft {
			width: 330px;

			.renli {
				height: 128px;
				transition: all 0.5s;
				display: flex;
				align-items: center;
				padding: 0 15px 0 22px;
				cursor: pointer;
				border-radius: 5px;

				.renpic {
					width: 47px;
					height: 42px;
					flex-shrink: 0;
				}

				.renpica {
					display: none;
					width: 47px;
					height: 42px;
					flex-shrink: 0;
				}

				.rencen {
					flex-grow: 1;
					padding: 0 12px;

					.centitle {
						font-size: 22px;
						color: #888888;
						padding-bottom: 11px;
					}

					.centxt {
						font-size: 18px;
						color: #c4c4c4;
						width: 160px;
					}
				}

				.renrr {
					width: 32px;
					height: 32px;
					margin-top: 15px;
				}

				.renact {
					width: 32px;
					height: 32px;
					margin-top: 15px;
					display: none;
				}
			}

			.renliactive {
				background-color: #0289f4;
				box-shadow: 0 0 18px #0289f4;

				.rencen {
					flex-grow: 1;
					padding: 0 12px;

					.centitle {
						color: #ffffff;
					}

					.centxt {
						color: #ffffff;
					}
				}

				.renrr {
					display: none;
				}

				.renact {
					display: block;
				}
			}
		}

		.renda {
			position: relative;
			width: 1052px;
			height: 512px;

			.rendapic {
				width: 1052px;
				height: 512px;
			}

			.rending {
				width: 205px;
				height: 40px;
				border-radius: 5px;
				background: rgba(255, 66, 0, 1);
				text-align: center;
				line-height: 40px;
				color: #ffffff;
				font-size: 18px;
				position: absolute;
				bottom: 18px;
				left: 50%;
				margin-left: -102.5px;
				cursor: pointer;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.banxin {
			width: 98%;
			margin: 0 auto;
			display: block;
			overflow: hidden;
		}

		.qiyetop .zhengtitle {
			font-size: 2.8rem;
		}

		.allbox .kehuibox .kehuitop {
			flex-wrap: wrap;
			height: auto;
		}

		.allbox .kehuibox .kehuitop .kehuipic {
			width: 100%;
			height: 20rem;
		}

		.allbox .kehuibox .kehuitop .kehuiyou {
			width: 80%;
		}

		.allbox .kehuibox .kehuitop .kehuiyou .ketitle {
			font-size: 2rem;
		}

		.allbox .kehuibox .kehuitop .kehuiyou .kehuitxt {
			font-size: 1.6rem;
			line-height: 2.6rem;
			margin-bottom: 2.5rem;
			-webkit-line-clamp: 6;
		}

		.allbox .kehuibox .keqie {
			flex-wrap: wrap;
			height: auto;
		}

		.allbox .kehuibox .keqie .qieli {
			width: 50%;
		}

		.allbox .kehuibox .keqie .qieli .qietitle {
			font-size: 1.8rem;
		}

		.zhengyxy {
			font-size: 1.6rem;
			line-height: 2.5rem;
			padding: 0 2rem 2rem;
		}

		.allbox .quanbox {
			flex-wrap: wrap;
			height: auto;
		}

		.allbox .quanbox .quangrow {
			width: 100%;
			padding: 2rem 1.5rem;
		}

		.allbox .quanbox .quangrow .quantitle {
			font-size: 2rem;
		}

		.allbox .quanbox .quangrow .quanhuitxt {
			font-size: 1.6rem;
			line-height: 2.5rem;
		}

		.allbox .quanbox .quangrow .jinlan {
			width: 16rem;
			height: 3rem;
			line-height: 3rem;
			font-size: 1.6rem;
		}

		.allbox .quanbox .quanpic {
			width: 100%;
			height: 30rem;
		}

		.rennei {
			flex-wrap: wrap;
		}

		.rennei .renleft {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		.rennei .renleft .renli {
			width: 50%;
			height: 8rem;
		}

		.rennei .renleft .renli .renpic {
			width: 3.5rem;
			height: 3.1rem;
		}

		.rennei .renleft .renli .rencen .centitle {
			font-size: 1.8rem;
		}

		.rennei .renleft .renli .rencen .centxt {
			font-size: 1.4rem;
			width: 10rem;
		}
	}
</style>